import api from '@/api';
import Vue from 'vue';

// Coalesce the selectors in a menu/ingredient table into one request per restaurant.
const requests = new Map();
const states = new Map();
export function updateStationState(firmId, data) {
  const key = String(firmId);
  if (!states.has(key)) states.set(key, Vue.observable({ ready: false, stations: [] }));
  const state = states.get(key);
  Object.assign(state, data);
  return state;
}
export function loadStations(axios, firmId, refresh = false) {
  if (refresh) requests.delete(String(firmId));
  const key = String(firmId);
  if (!requests.has(key)) {
    const promise = axios.get(api.restaurants.stations.base(firmId))
      .then(response => updateStationState(firmId, response.data))
      .catch(error => { requests.delete(key); throw error; });
    requests.set(key, promise);
    setTimeout(() => { if (requests.get(key) === promise) requests.delete(key); }, 15000);
  }
  return requests.get(key);
}
export function invalidateStations(firmId) {
  requests.delete(String(firmId));
}
